<template>
    <j-page class="user-manage-layout">
        <div slot="search"  v-if="search">
            <j-page-search title="角色">
                <el-select v-model="query.roleId" placeholder="请选择角色" clearable filterable>
                    <el-option v-for="item in roleList" :key="item.roleId" :label="item.name" :value="item.roleId" />
                </el-select>
            </j-page-search>
            <j-page-search title="用户名">
                <el-input v-model="query.username" @keydown.native.enter="searchEvent" placeholder="请输入用户名" clearable />
            </j-page-search>
            <j-page-search title="姓名">
                <el-input v-model="query.name" @keydown.native.enter="searchEvent" placeholder="请输入姓名" clearable />
            </j-page-search>
            <j-page-search title="联系电话">
                <el-input v-model="query.mobile" @keydown.native.enter="searchEvent" placeholder="请输入联系电话" clearable />
            </j-page-search>
            <j-page-search title="用户状态">
                <el-radio-group v-model="query.status">
                    <el-radio label="">全部</el-radio>
                    <el-radio :label="true">启用</el-radio>
                    <el-radio :label="false">禁用</el-radio>
                </el-radio-group>
            </j-page-search>
            <el-button type="primary" icon="el-icon-search" @click="searchEvent">查询</el-button>
            <el-button type="info" icon="el-icon-refresh" @click="resetEvent">重置</el-button>
            <el-button type="warning" icon="el-icon-plus" @click="addDrmxEvent">新增</el-button>
        </div>
        <div slot="table">
            <el-table v-loading="tableLoading" :data="tableData" height="100%" stripe>
                <el-table-column prop="username" label="用户名" align="center" show-overflow-tooltip />
                <el-table-column prop="name" label="姓名" align="center" show-overflow-tooltip />
                <el-table-column prop="sex" label="性别" align="center" show-overflow-tooltip>
                    <j-dictionary slot-scope="{row}" code="GENDER" :value="row.sex" />
                </el-table-column>
                <el-table-column prop="mobile" label="联系电话" align="center" show-overflow-tooltip />
<!--                <el-table-column prop="deptName" label="所属机构" align="center" show-overflow-tooltip />-->
                <el-table-column prop="createTime" label="最近登录时间" align="center" show-overflow-tooltip />
                <el-table-column prop="roleName" label="角色" align="center" show-overflow-tooltip />
                <el-table-column prop="status" label="状态" align="center" show-overflow-tooltip>
                    <el-tag slot-scope="{row}" :type="row.status == false ? 'warning' : 'success'">{{statusMap[row.status]}}</el-tag>
                </el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button @click.stop="editDrmxEvent(scope.row)" type="text" class="common-button-edit">编辑</el-button>
                        <el-button @click.stop="delEvent(scope.row)" type="text" class="common-button-del" >删除</el-button>
                        <el-button @click.stop="editDgmxEvent(scope.row)" type="text" class="common-button-add">重置密码</el-button>
                        <el-button @click.stop="changeUserStatus(scope.row, true)" v-if="scope.row.status == 0"  type="text" class="common-button-add">启用</el-button>
                        <el-button @click.stop="changeUserStatus(scope.row, false)" v-else  type="text" class="common-button-del">禁用</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div slot="pagination" v-show="query.total > query.limit">
            <el-pagination
                    :current-page="query.page"
                    :page-size="query.limit"
                    :total="query.total"
                    :background="pmxBackground"
                    :pager-count="pmxCount"
                    :layout="pmxLayout"
                    :pageSizes="pmxSizes"
                    @current-change="changePage"
                    @size-change="sizeChange"
            />
        </div>

        <el-dialog v-if="showDgmx" title="重置密码" :visible.sync="showDgmx" width="400px" :close-on-click-modal="false">
            <el-form ref="dgmxDom" :model="dgmxForm" :rules="dgmxRule" @keydown.native.enter="checkDgmxEvent('saveDgmxData')">
                <el-form-item label="新密码" prop="newPwd">
                    <j-input type="password" v-model="dgmxForm.newPwd" placeholder="请输入新密码" clearable />
                </el-form-item>
                <el-form-item label="重复密码" prop="newPwdConfim">
                    <j-input type="password" v-model="dgmxForm.newPwdConfim" placeholder="请重复密码" clearable />
                </el-form-item>
            </el-form>
            <template slot="footer">
                <el-button type="primary" @click="checkDgmxEvent('saveDgmxData')" :loading="submitLoad">保存</el-button>
                <el-button type="info" @click="showDgmx = false">取消</el-button>
            </template>
        </el-dialog>

        <j-drawer :title="drmxTypeMap[drmxType]" :close.sync="showDrmx">
            <div>
                <el-form ref="drmxDom" :model="drmxForm" :rules="drmxRule" :label-width="drmxFormLabelWidth" @keydown.native.enter="checkDrmxEvent('saveDrmxData')">
                    <j-drawer-label type="title" title="用户信息" />
                    <div style="padding: 5px 10px 0;">
                        <el-form-item label="角色" prop="roleId">
                            <el-select v-model="drmxForm.roleId" :disabled="!search" placeholder="请选择角色" style="width: 100%" clearable filterable @change="roleChange">
                                <el-option v-for="item in roleList" :key="item.roleId" :label="item.name" :value="item.roleId" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="用户名" prop="username">
                            <el-input v-model="drmxForm.username" placeholder="请输入用户名" maxlength="200" clearable />
                        </el-form-item>
                        <el-form-item label="姓名" prop="name">
                            <el-input v-model="drmxForm.name" placeholder="请输入姓名" maxlength="200" clearable />
                        </el-form-item>
                        <el-form-item label="性别" prop="sex">
                            <j-dictionary type="select" v-model="drmxForm.sex" code="GENDER" placeholder="请选择性别" />
                        </el-form-item>
                        <el-form-item label="联系电话" prop="mobile">
                            <el-input v-model="drmxForm.mobile" placeholder="请输入联系电话" clearable />
                        </el-form-item>
<!--                        <el-form-item label="机构" prop="orgId">-->
<!--                            <el-select v-model="drmxForm.orgId" placeholder="请选择机构" style="width: 100%" clearable filterable>-->
<!--                                <el-option v-for="(item, i) in []" :key="i" :label="item.name" :value="item.id" />-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
                    </div>
                </el-form>
            </div>
            <div slot="footer" style="width: 100%;">
                <el-button style="width: 100%;" @click="checkDrmxEvent('saveDrmxData')" :loading="submitLoad">保存</el-button>
            </div>
        </j-drawer>
    </j-page>
</template>

<script>
    import encrypt from "../../utils/encrypt/encrypt";
    import PageMixins from "../../components/JComponents/JPage/mixins/PageMixins";
    import DialogMixins from "../../components/JComponents/JPage/mixins/DialogMixins";
    import DrawerMixins from "../../components/JComponents/JPage/mixins/DrawerMixins";
    import PaginationMixins from "../../components/JComponents/JPage/mixins/PaginationMixins";
    import ValidatorMixins from "../../components/JComponents/JPage/mixins/ValidatorMixins";
    export default {
        name: "UserManage",
        mixins: [PageMixins, DialogMixins, DrawerMixins, PaginationMixins, ValidatorMixins],
        props: {
          search: {
              type: Boolean,
              default: true
          }
        },
        data () {
            return {
                roleList: [],
                statusMap: {
                    false: '禁用',
                    true: '启用'
                },
                query: {
                    areaCode: '',
                    deptId: '',
                    mobile: '',
                    status: '',
                    username: '',
                    name: '',
                    roleId: ''
                },
                drmxForm: {
                    "avataUrl": "",
                    "email": "",
                    "mobile": "",
                    "name": "",
                    "orgId": "",
                    "roleId": "",
                    "sex": "",
                    "username": ""
                },
                drmxRule: {
                    username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                    name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                    roleId: [{ required: true, message: '请选择角色', trigger: 'change' }],
                    sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
                    email: [{ required: false, validator: this.emailValidator, trigger: 'blur' }],
                    mobile: [{ required: false, validator: this.phoneValidator, trigger: 'blur' }]
                },
                dgmxForm: {
                    "adminId": '',
                    "newPwd": "",
                    "newPwdConfim": ""
                },
                dgmxRule: {
                    newPwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                    newPwdConfim: [{ required: true, validator: this.passValidator, trigger: 'blur' }]
                },
                cascaderProps: { children: 'childrens', label: 'name', value: 'id', emitPath: false },
                org: {}
            }
        },
        created () {
            this.getRoleList()
            if (this.search) this.load(this.org)
        },
        methods: {
            roleChange () {
                this.drmxForm.orgId = ''
                this.drmxForm.orgName = ''
                this.drmxForm.roleName = ''
            },
            addDrmxEvent () {
                if (!this.search) this.drmxForm.roleId = this.org.parentId ? 4 : 3
                this.drmxType = 'ADD'
                this.showDrmx = true
            },
            editDrmxEvent (row) {
                if (!this.search) this.drmxForm.roleId = this.org.parentId ? 4 : 3
                this.drmxType = 'EDIT'
                this.curItem = { ...row }
                this.drmxForm = this.proxyDrmxData({ ...this.drmxForm, ...row })
                this.showDrmx = true
            },
            passValidator (rule, value, callback) {
                if (!value && rule.required) {
                    callback(new Error('请确认密码'));
                } else if (value != this.dgmxForm.newPwd) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            },
            async load (org = {}) {
                this.org = org
                this.tableLoading = true
                const { data } = await this.$http.get(`/api/admins`, {
                    params:  { ...this.query, orgId: org.id }
                })
                this.tableData = data.data.data
                this.query.total = data.data.total
                this.tableLoading = false
            },
            async getRoleList () {
                const { data } = await this.$http.get(`/api/roles`)
                this.roleList = data.data
            },
            delEvent (row) {
                this.$confirm('您确认要删除当前用户吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http
                        .request({
                            method: 'delete',
                            url: `/api/admins/${row.adminId}`
                        })
                        .then((res) => {
                            if (res.data.status !== 'yes') return this.$message.error(res.data.msg)
                            this.pageUpdate(this.query)
                            this.$message.success('删除成功')
                            this.load && this.load(this.org)
                        })
                })
            },
            async changeUserStatus (row, status) {
                if (this.submitLoad) return
                this.submitLoad = true
                const {data} = await this.$http.put(`/api/admins/status`, { ...row, status })
                  .catch(({response}) => { this.$message.error(response.data.msg) })
                  .finally(() => { this.submitLoad = false })
                if (data.status !== 'yes') return this.$message.error(data.msg)
                this.$message.success('更新成功')
                this.load(this.org)
            },
            async saveDgmxData () {
                if (this.submitLoad) return
                this.submitLoad = true
                let method = 'put'
                let url = `/api/admins/resetPassword`
                const { data } = await this.$http[method](url, { ...this.dgmxForm,
                        newPwd: encrypt.getEncryptSM4(this.dgmxForm.newPwd),
                        newPwdConfim: encrypt.getEncryptSM4(this.dgmxForm.newPwdConfim)
                })
                    .catch(({response}) => { this.$message.error(response.data.msg) })
                    .finally(() => { this.submitLoad = false })
                if (data.status !== 'yes') return this.$message.error(data.msg)
                this.showDgmx = false
                this.$message.success('提交成功')
                this.load(this.org)
            },
            async saveDrmxData () {
                if (this.submitLoad) return
                this.submitLoad = true
                let method = 'post'
                let url = `/api/admins`
                if (this.drmxType === 'EDIT') {
                    url = `/api/admins`
                    method = 'put'
                }
                const { data } = await this.$http[method](url, this.drmxForm)
                    .catch(({response}) => { this.$message.error(response.data.msg) })
                    .finally(() => { this.submitLoad = false })
                if (data.status !== 'yes') return this.$message.error(data.msg)
                this.showDrmx = false
                this.$message.success('提交成功')
                this.load(this.org)
            }
        }
    }
</script>
